<mat-form-field class="chip-list" appearance="fill">
  <mat-label>Is Interested</mat-label>
  <mat-select [value]="isInterested()" multiple (valueChange)="onIsInterestedChange($event)">
    <mat-select-trigger>
      <mat-chip-listbox>
        @for(isInterestedUser of isInterested(); track isInterestedUser) {
        <mat-chip [removable]="true" >
          {{ isInterestedUser }}
        </mat-chip>
        }
      </mat-chip-listbox>
    </mat-select-trigger>
    @for (name of allUsers; track name ) {
    <mat-option [value]="name">
      {{ name }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>